import './quote.scss';
import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { icons } from '../../content/icons';
import { ImageUtils } from '../../utils/image';
import { ExpandingRegion } from '../layout/expandingRegion';
import { LazyCosmosImage } from '../media/cosmosImage';
export const Quote = ({ image, quoteText, author, expandable }) => {
    const [expanded, setExpanded] = React.useState(false);
    return (<div className="quote-wrapper">
      <div className="quote">
        <div className="quote-image-wrapper">
          {image && <LazyCosmosImage alt={image.alt} ticket={image.ticket} size={ImageUtils.imageSizes.squareVeryTiny}/>}
        </div>

        <div className="quote-text-wrapper" data-exapanded={expanded}>
          <div className="quote-text-wrapper-inner" data-expanded={expanded} data-expandable={expandable}>
            <ExpandingRegion expanded={expanded} minHeight={expandable ? 50 : 3000}>
              <div className="quote-text-outer">
                <ReactMarkdown className="quote-text" source={quoteText}/>
              </div>
            </ExpandingRegion>
          </div>

          {!!expandable && (<p className="expand-toggle" onClick={() => setExpanded(!expanded)}>
              {expanded ? (<>
                  <Icon {...icons.upChevron}/> Show Less
                </>) : (<>
                  <Icon {...icons.downChevron}/> Show More
                </>)}
            </p>)}

          <p className="quote-name">
            <strong>{author.name}</strong> {!!author.position && <i>{author.position}</i>}
          </p>

          
        </div>
      </div>
    </div>);
};
export default Quote;
